import { Component, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import moment from 'moment';

@Component({
  selector: 'app-service-cancellation-alert',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './service-cancellation-alert.component.html',
  styleUrl: './service-cancellation-alert.component.scss',
})
export class ServiceCancellationAlertComponent {
  readonly currentState = input<string>();
  readonly currentStateDate = input<Date | null>();
  readonly reasonText = input<string>();

  readonly show = computed(() => {
    const state = this.currentState();
    const canceledStates = ['Anulada', 'Cancelado', 'CANCELED', 'CANCELLED'];
    return !!state && canceledStates.includes(state);
  });

  readonly formattedDate = computed(() => {
    const date = this.currentStateDate();
    if (!date) return '-';
    return moment(date).format('DD/MM/YY HH:mm:ss');
  });

  readonly observationsText = computed(() => {
    return this.reasonText() || '-';
  });

  onClose(): void {}
}